module.exports = __webpack_public_path__ + "img/strawberry.63411c92.png";